export default __webpack_public_path__ + "static/media/login_bg_fasting@2x.03823288.jpg";